import { createSelector } from '@ngrx/store';
//
// NgRx Store
//
import { combineReducers, ActionReducerMap } from '@ngrx/store';
//
// Recucers
//
import * as fromSharedDataReducer from './reducers/shared-data.reducer';

import {
  IMenuState,
  MenuStateReducer,
  LoadMenu
} from './reducers/menu.reducer';

import {
  IDealerOption,
  DealerOptionReducer,
  LoadDealerOption,
} from './reducers/dealer-option.reducer';
import {
  IFeatureConfig,
  FeatureConfigReducer,
  LoadFeatureConfig,
} from './reducers/feature-config.reducer';

import {
  ILocalSpecial,
  LocalSpecialReducer,
  LoadLocalSpecial
} from './reducers/local-special.reducer';
import { ProtectionProductsReducer, IProtectionProducts,LoadProtectionProducts } from './reducers/protection-products.reducer';

//
// Applicaiton Store Definition
//
export interface IAppState {
  sharedDataState: fromSharedDataReducer.SharedDataState;
  menu: IMenuState;
  dealerOption: IDealerOption;
  localSpecial: ILocalSpecial;
  FeatureConfig: IFeatureConfig;
  ProtectionProducts: IProtectionProducts
}

//
// Application Store Reducers
//
export const reducers: ActionReducerMap<IAppState> = {
  sharedDataState: fromSharedDataReducer.reducer,
  menu: MenuStateReducer,
  dealerOption: DealerOptionReducer,
  localSpecial: LocalSpecialReducer,
  FeatureConfig: FeatureConfigReducer,
  ProtectionProducts:ProtectionProductsReducer
};

//
// Menu Store Selector
//
export const MenuStore = createSelector(
  (state: IAppState) => {
    return state.menu;
  },
  LoadMenu
);

//
// Dealer Option Store Selector
//
export const DealerOptionStore = createSelector(
  (state: IAppState) => {
    return state.dealerOption;
  },
  LoadDealerOption
);

//
// Local Special Store Selector
//
export const LocalSpecialStore = createSelector(
  (state: IAppState) => {
    return state.localSpecial;
  },
  LoadLocalSpecial
);

//
// Local Special Store Selector
//
export const ProtectionProductStore = createSelector(
  (state: IAppState) => {
    return state.ProtectionProducts;
  },
  LoadProtectionProducts
);


//
// Shared Data Selector
//
export const SharedDataStore = createSelector(
  (state: IAppState) => {
    return state.sharedDataState;
  },
  fromSharedDataReducer.getSharedData
);

//
// Dealer COnfiguration Store Selector
//
export const FeatureConfigStore = createSelector(
  (state: IAppState) => {
    return state.FeatureConfig;
  },
  LoadFeatureConfig
);
//
// Combined Selector
//
const combindSelector = createSelector(() => [], combineReducers)(reducers);

//
// Root Reducer
//
export function rootReducer(state: any, action: any) {
  return combindSelector(state, action);
}
